import kasparImage from '../../assets/images/kaspar-tiri.png';

export default function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <img 
            src={kasparImage} 
            alt="Kaspar Tiri - Estonian Entrepreneur" 
            className="profile-image"
          />
          <div className="profile-info">
            <h1 className="main-title">Kaspar Tiri</h1>
            <p className="main-subtitle">Estonian Entrepreneur</p>
            <p className="main-description">
              Co-founder of Ready Player Me, a cross-game avatar platform used by 150k+ developers. Raised $72M from a16z, Plural, and many others.
              </p>
              <p className="main-description" style={{ marginTop: '0.6em' }}>
              Acquired by Netflix in 2025.
              </p>
            <div className="social-links">
              <a 
                href="https://www.linkedin.com/in/kaspartiri/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-text"
              >
                LinkedIn
              </a>
              <span className="social-separator">·</span>
              <a 
                href="https://x.com/sussisisse" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link-text"
              >
                X
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

